import { render, staticRenderFns } from "./StartSigningProcessModal.vue?vue&type=template&id=710cd4ed&scoped=true&"
import script from "./StartSigningProcessModal.vue?vue&type=script&lang=js&"
export * from "./StartSigningProcessModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "710cd4ed",
  null
  
)

export default component.exports